'use client'

import type { StoreFrontDto } from '@b-stock/listing-api-client'

import type { useListingSearch } from '../search/ListingSearchProvider'
import type {
  ListingFilterList,
  ListingFilterSet,
} from '../search/SearchFilters'
import SearchFilters from '../search/SearchFilters'
import FiltersModal from '../search/SearchFilters/FiltersModal'
import { useIsMobileTableLayout } from '../shared/useIsMobileTableLayout'

function FiltersBar({
  closeFilterModal,
  excludeSavedSearch,
  filters,
  hiddenFilters,
  searchCtx,
  showFilterModal,
  showRelevance,
  storefront,
}: {
  closeFilterModal: () => void
  excludeSavedSearch?: boolean
  filters: ListingFilterList
  hiddenFilters?: ListingFilterSet
  searchCtx: ReturnType<typeof useListingSearch>
  showFilterModal: boolean
  showRelevance: boolean
  storefront?: StoreFrontDto
}) {
  const isMobileFilterShown = useIsMobileTableLayout()

  return (
    <>
      <FiltersModal
        closeFilterModal={closeFilterModal}
        filters={filters}
        searchCtx={searchCtx}
        showFilterModal={isMobileFilterShown && showFilterModal}
        showRelevance={showRelevance}
        showSortBy
        showStorefrontSearch={!!storefront}
        storefront={storefront}
      />
      {!isMobileFilterShown && (
        <SearchFilters
          excludeSavedSearch={excludeSavedSearch}
          filters={filters}
          hiddenFilters={hiddenFilters}
          searchCtx={searchCtx}
        />
      )}
    </>
  )
}

export default FiltersBar
